"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
// Create a Lazy editor plugin type
// Parameters:
//  lazyModule: lazyModule from which to get the PluginClass
//  getter: function to get the PluginClass from the lazyModule once it is loaded
//  importTrigger: (optional) a function to check if the real plugin need to be loaded. If null, the plugin will be loaded immediately when initialize
// Usage:
//  (Suppose MyPlugin is the type of real plugin, myImportTrigger is the trigger function)
//
// import * as MyPluginModule from './MyPlugin';
//
// const lazyModule = new LazyModule(() =>
//     System.import<typeof MyPluginModule>(
//         /* webpackChunkName: "MyPlugin" */ './MyPlugin'
//     )
// );
//
// export let LazyMyPluginClass = createLazyPlugin(
//     lazyModule,
//     m => m.default,
//     myImportTrigger);
//
// When use this plugin:
//    let myPlugin: LazyMyPlugin = new LazyMyPluginClass(...);
//    let myRealPlugin = await myPlugin.getPlugin();
function createLazyPlugin(lazyModule, getter, importTrigger) {
    return /** @class */ (function () {
        function class_1() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            this.onImportedCallbacks = [];
            this.args = args;
        }
        class_1.prototype.initialize = function (editor) {
            this.editor = editor;
            if (this.pluginInstance) {
                this.initializeAndCallback();
            }
            else if (!importTrigger) {
                this.internalImport();
            }
        };
        class_1.prototype.dispose = function () {
            if (this.pluginInstance) {
                this.pluginInstance.dispose();
                this.pluginInstance = null;
            }
            this.editor = null;
            this.importPluginPromise = null;
            // reset to empty array in case this plugin is reused
            this.onImportedCallbacks = [];
        };
        class_1.prototype.setPluginUtils = function (pluginUtils) {
            this.pluginUtils = pluginUtils;
            if (this.pluginInstance) {
                var pluginEx = this.pluginInstance;
                if (pluginEx.setPluginUtils) {
                    pluginEx.setPluginUtils(this.pluginUtils);
                }
            }
        };
        class_1.prototype.onPluginEvent = function (event) {
            if (this.pluginInstance) {
                if (this.pluginInstance.onPluginEvent) {
                    this.pluginInstance.onPluginEvent(event);
                }
            }
            else if (importTrigger && importTrigger(event, this.editor)) {
                this.internalImport(event);
            }
        };
        class_1.prototype.willHandleEventExclusively = function (event) {
            if (this.pluginInstance && this.pluginInstance.willHandleEventExclusively) {
                return this.pluginInstance.willHandleEventExclusively(event);
            }
            else {
                return false;
            }
        };
        class_1.prototype.getPlugin = function () {
            if (this.pluginInstance) {
                return Promise.resolve(this.pluginInstance);
            }
            else {
                return this.internalImport();
            }
        };
        class_1.prototype.isImported = function () {
            return !!this.pluginInstance;
        };
        class_1.prototype.addOnImportedCallback = function (callback) {
            if (this.isImported()) {
                callback(this.pluginInstance);
            }
            else if (this.onImportedCallbacks) {
                this.onImportedCallbacks.push(callback);
            }
        };
        class_1.prototype.initializeAndCallback = function () {
            var _this = this;
            this.pluginInstance.initialize(this.editor);
            this.onImportedCallbacks.forEach(function (callback) { return callback(_this.pluginInstance); });
        };
        class_1.prototype.internalImport = function (event) {
            var _this = this;
            if (!this.importPluginPromise) {
                this.importPluginPromise = new owa_bundling_1.LazyImport(lazyModule, getter)
                    .import()
                    .then(function (PluginClass) {
                    _this.pluginInstance = new (PluginClass.bind.apply(PluginClass, [void 0].concat(_this.args)))();
                    var pluginEx = _this.pluginInstance;
                    if (pluginEx.setPluginUtils) {
                        pluginEx.setPluginUtils(_this.pluginUtils);
                    }
                    if (_this.editor) {
                        _this.initializeAndCallback();
                        if (event) {
                            _this.pluginInstance.onPluginEvent(event);
                        }
                    }
                    return _this.pluginInstance;
                });
            }
            return this.importPluginPromise;
        };
        return class_1;
    }());
}
exports.default = createLazyPlugin;
//# sourceMappingURL=createLazyPlugin.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-editor-lazy-plugin/lib/utils/createLazyPlugin.js
// module id = 1549
// module chunks = 2 3 59 108